<div *ngIf="tenant">
  <div class="card p-0 pt-4 mb-0">
    <div class="flex flex-column mx-4 mb-3">
      <div class="flex flex-column sm:flex-row justify-content-start sm:justify-content-between">
        <p class="inline-block text-4xl flex-order-1 sm:flex-order-0">
          {{'model.tenant' | transloco}} {{tenant.name}}
        </p>
        <div class="flex-order-0 sm:flex-order-1">
          <button
            *ngIf="'ROLE_ADMIN' | userHasRole"
            [label]="'common.edit' | transloco"
            pButton
            pRipple
            class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
            routerLink="../edit"
            icon="pi pi-pencil"
          ></button>
        </div>
      </div>
      <div>
        <p *ngIf="tenant.description"><b>{{'attribute.description' | transloco}}: </b>{{tenant.description}}</p>
        <p *ngIf="!tenant.description" class="font-italic">{{'empty.description' | transloco}}</p>
      </div>
    </div>
    <div>
      <p-tabMenu
        #tab
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tab)"
        class="display-none xxl:inline"
      ></p-tabMenu>
      <p-tabMenu
        #tabIcon
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tabIcon)"
        class="xxl:hidden"
      >
        <ng-template pTemplate="item" let-item let-i="index">
          <i [className]="item.icon"></i>
        </ng-template>
      </p-tabMenu>
    </div>
  </div>
  <div class="with-margin" *ngIf="activeItem">
    <app-tenant-overview [tenant]="tenant" *ngIf="activeItem.id === 'overview'"></app-tenant-overview>
    <app-tenant-api [tenant]="tenant" *ngIf="activeItem.id === 'api'"></app-tenant-api>
    <app-tenant-organizations [tenant]="tenant" *ngIf="activeItem.id === 'organizations'"></app-tenant-organizations>
    <app-tenant-decoders [tenant]="tenant" *ngIf="activeItem.id === 'decoders'"></app-tenant-decoders>
    <app-tenant-asset-representations [tenant]="tenant" *ngIf="activeItem.id === 'assetRepresentations'"></app-tenant-asset-representations>
    <app-tenant-device-categories [tenant]="tenant" *ngIf="activeItem.id === 'deviceCategories'"></app-tenant-device-categories>
    <app-tenant-trigger-rules [tenant]="tenant" *ngIf="activeItem.id === 'triggerRules'"></app-tenant-trigger-rules>
    <app-tenant-measurement-types [tenant]="tenant" *ngIf="activeItem.id === 'measureTypes'"></app-tenant-measurement-types>
    <app-tenant-property-types [tenant]="tenant" *ngIf="activeItem.id === 'propertyTypes'"></app-tenant-property-types>
  </div>
</div>
